import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { themes } from '@olist/design-system-tokens';
import { Box } from '../Box/Box.js';

function ProgressCircle(_a) {
    var { label, currentStep, totalSteps, variation = 'primary', size = 'medium', counterClockwise = false } = _a, props = __rest(_a, ["label", "currentStep", "totalSteps", "variation", "size", "counterClockwise"]);
    const strokeWidth = 10;
    const normalizedCurrent = currentStep > totalSteps ? totalSteps : currentStep;
    const radius = 50 - strokeWidth / 2;
    const dashRatio = normalizedCurrent / totalSteps;
    const diameter = Math.PI * 2 * radius;
    const gapLength = (1 - dashRatio) * diameter;
    const { olist: { base: theme }, } = themes;
    return (React.createElement(Box, Object.assign({ w: theme.components.progresscircle.size[size], h: theme.components.progresscircle.size[size] }, props),
        React.createElement("svg", { viewBox: "0 0 100 100" },
            React.createElement("path", { fillOpacity: 0, stroke: theme.color.neutral.softer, strokeDashoffset: 1, strokeWidth: strokeWidth - 1, d: `
            M 50,50
            m 0,-${radius}
            a ${radius},${radius} 1 1 1 0,${radius * 2}
            a ${radius},${radius} 1 1 1 0,-${radius * 2}
          ` }),
            React.createElement("path", { role: "progressbar", fillOpacity: 0, stroke: theme.components.progresscircle.variation[variation], strokeDasharray: diameter, strokeDashoffset: counterClockwise ? gapLength * -1 : gapLength, strokeLinecap: "round", strokeWidth: strokeWidth, d: `
            M 50,50
            m 0,-${radius}
            a ${radius},${radius} 1 1 1 0,${radius * 2}
            a ${radius},${radius} 1 1 1 0,-${radius * 2}
          ` }),
            React.createElement("text", { x: "50%", y: "53%", dominantBaseline: "middle", fill: theme.color.neutral.stronger, fontSize: theme.fontSize['2xhuge'], textAnchor: "middle" }, label))));
}

export { ProgressCircle as default };
